import React, { useState, useEffect } from 'react'
import { matchPath, useLocation } from 'react-router'
import { APP_ROUTES, PLATFORM_ROUTE_GROUPS } from 'src/app/routes/routes.constants'
import { createContext } from 'src/utils/context'
import { extractStringsFromObject } from 'src/utils/string'

export type PlatformManagerContext = {
  isVisible: boolean
  setIsVisible: (isVisible: boolean) => void
  isPlatformPath: boolean
}

const [usePlatformManager, PlatformManagerCtx] = createContext<PlatformManagerContext>()
const listAppRoutes = extractStringsFromObject(APP_ROUTES)

function checkIsPathCurrentRoute(route: String) {
  const hasDinamicParam = route.includes(':')
  const isForAllPaths = route.includes('*')

  if (hasDinamicParam) {
    const query = route.split(':')[0].replace(/.$/, '')

    return location.pathname.startsWith(query)
  }

  if (isForAllPaths) {
    const query = route.replace('/*', '').replace('*', '')

    return location.pathname.startsWith(query)
  }

  return (route as string) === location.pathname
}

const replaceDynamicPathnameByRouterWritten = (pathName: string) => {
  const match = PLATFORM_ROUTE_GROUPS.map(route =>
    matchPath(pathName, {
      path: route,
      exact: true,
      strict: false
    })
  ).filter(e => e)[0]

  return match?.path ?? ''
}

const Provider = ({ children }) => {
  const [isVisible, setIsVisible] = useState<PlatformManagerContext['isVisible']>(false)
  const [isPlatformPath, setIsPlatformPath] = useState<PlatformManagerContext['isPlatformPath']>(false)
  const location = useLocation()

  useEffect(() => {
    const isArouteCoveredByApp = listAppRoutes.some(checkIsPathCurrentRoute)

    const pathnameTreated = replaceDynamicPathnameByRouterWritten(location.pathname)

    const isPlaformCurrentPath = PLATFORM_ROUTE_GROUPS.includes(pathnameTreated) || !isArouteCoveredByApp

    setIsPlatformPath(isPlaformCurrentPath)

    const style = document.createElement('style')

    if (location.pathname === '/age-limit') {
      style.setAttribute('id', 'withoutToolbar')

      style.innerHTML = `
        body #root {
          padding-top: 0 !important;
        }
      `

      document.body.appendChild(style)
    }

    return () => {
      style.remove()
    }
  }, [location.pathname])

  return (
    <PlatformManagerCtx
      value={{
        isVisible,
        setIsVisible,
        isPlatformPath
      }}
    >
      {children}
    </PlatformManagerCtx>
  )
}

export { usePlatformManager, Provider }
